import { Component, HostListener, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomFieldSummary } from '@me-fit-mono/typings';

@Component({
  selector: 'me-custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFieldComponent),
      multi: true,
    },
  ],
})
export class CustomFieldComponent implements OnInit, ControlValueAccessor {
  internalValue = new FormControl();

  onTouchedCallback: Function = () => { };

  @Input() customField: CustomFieldSummary;

  @Input() showLabel: boolean = true;

  @Input() placeholder: unknown;

  @HostListener('focusout')
  onBlur() {
    this.onTouchedCallback();
  }

  constructor() { }

  ngOnInit() {
  }

  writeValue(obj: unknown): void {
    this.internalValue.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.internalValue.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.internalValue.disabled == isDisabled) {
      return;
    }

    if (isDisabled) {
      this.internalValue.disable();
    } else {
      this.internalValue.enable();
    }
  }
}
